import React from 'react';
import { NavLink } from 'react-router-dom';
import Logout from '../login/Logout';
import { authPuedeGestionFamiliar } from '../../lib/authSession';

const SideBarPaciente = ({ onClose, showCloseOnMovil }) => {
  const handleClick = () => {
    if (typeof onClose === 'function') onClose();
  };

  return (
  <nav className="sideBar" id="sideBarPaciente">
    <div className="menu">
      <div className="menu__head">
        <div className="title"><h5>Menú</h5></div>
        {showCloseOnMovil && (
          <button type="button" className="sideBar__close d-lg-none" onClick={onClose} aria-label="Cerrar menú">
            <i className="bi bi-x-lg" />
          </button>
        )}
      </div>
      <ul className="navbar-nav">
        <li className="nav-item">
          <NavLink end to="/inicio" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleClick}>
            <i className="bi bi-house"></i> Inicio
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/inicio/realizar_reserva" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleClick}>
            <i className="bi bi-calendar-plus"></i> Nuevo Turno
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/inicio/mis_reservas" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleClick}>
            <i className="bi bi-calendar-check"></i> Mis Turnos
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/inicio/configuracion_cuenta" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleClick}>
            <i className="bi bi-person-gear"></i> Mis datos
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/inicio/notificaciones" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleClick}>
            <i className="bi bi-bell"></i> Notificaciones
          </NavLink>
        </li>
        {authPuedeGestionFamiliar() && (
          <>
            <li className="sideBar__seccion-separador" aria-hidden="true" />
            <li className="sideBar__seccion-titulo">
              <span className="sideBar__seccion-titulo-texto">Gestión familiar</span>
            </li>
            <li className="nav-item">
              <NavLink to="/inicio/hub_familiar" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleClick}>
                <i className="bi bi-grid"></i> Familia relacionada
              </NavLink>
            </li>
            <li className="nav-item" title="Dar de alta a alguien que aún no está en el sistema">
              <NavLink to="/inicio/solicitar_paciente" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleClick}>
                <i className="bi bi-person-plus"></i> Agregar nuevo familiar
              </NavLink>
            </li>
            <li className="nav-item" title="Vincular con alguien que ya tiene cuenta">
              <NavLink to="/inicio/solicitar_vinculacion" className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleClick}>
                <i className="bi bi-link-45deg"></i> Vincular cuenta existente de familiar
              </NavLink>
            </li>
          </>
        )}
        <li className="nav-item logout">
          <Logout />
        </li>
      </ul>
    </div>
  </nav>
  );
};

export default SideBarPaciente;
